var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "table-detail",
      class: {
        "module-mode": _vm.moduleMode,
        "table-mode": _vm.currentBoardView === "table",
        "kanban-mode": _vm.currentBoardView === "kanban",
        "calendar-mode": _vm.currentBoardView === "calendar",
        "page-mode": !["table", "kanban", "calendar"].includes(
          _vm.currentBoardView
        ),
      },
    },
    [
      _vm.table
        ? _c(
            "TableToolbar",
            {
              attrs: {
                fields: _vm.tableFields,
                filters: _vm.filterConditions,
                selectedRecords: _vm.selectedRecords,
                "table-id": _vm.tableId,
                table: _vm.table,
                hiddenFields: _vm.hiddenFields,
                lockedFields: _vm.lockedFields,
                sort: _vm.currentSort,
                "current-view": _vm.currentView,
                total: _vm.total,
                cursor: _vm.cursor,
                moduleMode: _vm.moduleMode,
                predefinedValues: _vm.predefinedValues,
                "group-value": _vm.groupValue,
                "current-board-view": _vm.currentBoardView,
                "color-conditions": _vm.colorConditions,
                "search-query": _vm.searchQuery,
                "selected-module": _vm.selectedModule,
                "default-linked-record-cache": _vm.defaultLinkedRecordCache,
                "custom-pages": _vm.customPages,
              },
              on: {
                "filter-updated": _vm.onFilterUpdated,
                search: _vm.onSearch,
                "records-deleted": _vm.onRecordsDeleted,
                "records-duplicated": _vm.onRecordsDuplicated,
                "edit-records": _vm.onEditRecords,
                "show-hide-fields": _vm.openHideFieldsPanel,
                "clear-hidden-fields": _vm.showAllFields,
                "view-created": _vm.onViewCreated,
                "show-view": _vm.onShowView,
                "edit-view": _vm.$_.noop,
                "create-new-view": _vm.createNewView,
                "open-import-modal": _vm.openImportModal,
                "record-created": _vm.onRecordCreated,
                "change-cursor": _vm.changeCursor,
                "group-changed": _vm.onGroupChanged,
                "board-view-changed": _vm.onBoardViewChanged,
                "update-color-conditions": _vm.onColorConditionsChanged,
                "download-selected-records": function ($event) {
                  return _vm.downloadRecordsAsExcel(true)
                },
                "download-all-records": function ($event) {
                  return _vm.downloadRecordsAsExcel(false)
                },
                "page-created": _vm.onPageCreated,
                "page-updated": _vm.onPageUpdated,
                "page-deleted": _vm.onPageDeleted,
              },
            },
            [
              _c(
                "a-button",
                { on: { click: _vm.openCreateViewModal } },
                [
                  _c("a-icon", { attrs: { type: "plus" } }),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("tables.newView")) +
                      "\n        "
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-body" },
        [
          _vm.currentBoardView === "table"
            ? [
                _vm.table
                  ? _c("TableHeaders", {
                      attrs: {
                        table: _vm.table,
                        isSelectionModeActive: _vm.isSelectionModeActive,
                        selectedRecords: _vm.selectedRecords,
                        isAllSelected: _vm.isAllSelected,
                        visibleFields: _vm.visibleFields,
                        moduleMode: _vm.moduleMode,
                      },
                      on: {
                        "positions-changed": _vm.onPositionsChanged,
                        "refresh-table": _vm.fetchTable,
                        "toggle-select-all": _vm.toggleSelectAll,
                        "hide-field": _vm.hideField,
                        "sort-changed": _vm.onSortChanged,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.table
                  ? _c("TableRecords", {
                      attrs: {
                        table: _vm.table,
                        records: _vm.records,
                        isSelectionModeActive: _vm.isSelectionModeActive,
                        selectedRecords: _vm.selectedRecords,
                        visibleFields: _vm.visibleFields,
                        pickerMode: _vm.pickerMode,
                        groupValue: _vm.groupValue,
                        getRecordColor: _vm.getRecordColor,
                        loading: _vm.loading,
                        filters: _vm.filterConditions,
                      },
                      on: {
                        "record-updated": _vm.recordUpdated,
                        "toggle-selection": _vm.toggleSelection,
                        "record-selected": _vm.onRecordSelected,
                        "update-filters": _vm.onFilterUpdated,
                      },
                    })
                  : _vm._e(),
              ]
            : _vm.currentBoardView === "kanban"
            ? _c(
                "div",
                { staticClass: "kanban-placeholder h-100" },
                [
                  _vm.table
                    ? _c("TableKanbanView", {
                        attrs: {
                          table: _vm.table,
                          records: _vm.records,
                          selectedRecords: _vm.selectedRecords,
                          isSelectionModeActive: _vm.isSelectionModeActive,
                          getRecordColor: _vm.getRecordColor,
                          groupValue: _vm.groupValue,
                        },
                        on: {
                          "record-updated": _vm.recordUpdated,
                          "toggle-selection": _vm.toggleSelection,
                          "board-view-changed": function ($event) {
                            _vm.currentBoardView = $event
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm.currentBoardView === "calendar"
            ? _c(
                "div",
                { staticClass: "calendar-placeholder h-100" },
                [
                  _vm.table
                    ? _c("TableCalendarView", {
                        attrs: {
                          records: _vm.records,
                          table: _vm.table,
                          selectedRecords: _vm.selectedRecords,
                          isSelectionModeActive: _vm.isSelectionModeActive,
                          getRecordColor: _vm.getRecordColor,
                          groupValue: _vm.groupValue,
                        },
                        on: {
                          "record-updated": _vm.recordUpdated,
                          "toggle-selection": _vm.toggleSelection,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm.currentBoardView &&
              _vm.customPages.some(function (page) {
                return page._id === _vm.currentBoardView
              })
            ? _c("TablePage", {
                attrs: {
                  page: _vm.currentPage,
                  table: _vm.table,
                  "upstream-filters": {
                    filters: _vm.$_.concat(
                      _vm.implicitFilters,
                      _vm.filterConditions
                    ),
                    searchQuery: _vm.searchQuery,
                  },
                },
                on: { "page-updated": _vm.onPageUpdated },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.table && _vm.loading
            ? _c(
                "div",
                { staticClass: "loading-overlay" },
                [_c("a-spin", { attrs: { size: "large" } })],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      ["table", "kanban", "calendar"].includes(_vm.currentBoardView)
        ? _c("TableFooter", {
            attrs: {
              "record-count": _vm.total,
              "table-id": _vm.tableId,
              disabled: _vm.loading || _vm.isCreatingRecord,
              cursor: _vm.cursor,
              moduleMode: _vm.moduleMode,
            },
            on: {
              "change-cursor": _vm.changeCursor,
              "create-new-record": _vm.onCreateNewRecord,
              "open-import-modal": _vm.openImportModal,
              "export-records": _vm.downloadRecordsAsExcel,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showEditMultiRecordModal
        ? _c(
            "Modal2",
            {
              attrs: {
                showFooter: false,
                title: _vm.$t("tables.editMultipleRecords"),
                className: "edit-multi-record-modal keydown-prevent-modal",
              },
              on: { cancel: _vm.closeEditMultiRecordModal },
            },
            [
              _c("EditMultiRecord", {
                attrs: {
                  table: _vm.table,
                  fields: _vm.tableFields,
                  selectedRecords: _vm.selectedRecords,
                },
                on: {
                  "records-updated": _vm.onRecordsUpdated,
                  cancel: _vm.closeEditMultiRecordModal,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showHideFieldsPanel
        ? _c("HideFields", {
            attrs: { fields: _vm.tableFields, hiddenFields: _vm.hiddenFields },
            on: {
              close: _vm.closeHideFieldsPanel,
              "hide-field": _vm.hideField,
              "show-field": _vm.showField,
              "show-all-fields": _vm.showAllFields,
              "hide-all-fields": _vm.hideAllFields,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showImportModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("tables.importRecords"),
                className: "import-records-modal keydown-prevent-modal",
                "show-footer": false,
              },
              on: { cancel: _vm.closeImportModal },
            },
            [
              _c("ImportRecords", {
                attrs: {
                  table: _vm.table,
                  fields: _vm.tableFields,
                  "on-completed": _vm.closeImportModal,
                  "on-cancelled": _vm.closeImportModal,
                },
                on: {
                  "import-records": _vm.handleImport,
                  cancel: _vm.closeImportModal,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCreateViewModal
        ? _c(
            "Modal2",
            {
              attrs: { title: _vm.$t("tables.createNewView") },
              on: { cancel: _vm.closeCreateViewModal },
            },
            [
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  model: {
                    value: _vm.newViewTemplate,
                    callback: function ($$v) {
                      _vm.newViewTemplate = $$v
                    },
                    expression: "newViewTemplate",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "chart" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.chartTemplate"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "blank" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.blankTemplate"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "form" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.formTemplate"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "gantt" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.ganttTemplate"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "footer" },
                [
                  _c(
                    "a-button",
                    { key: "back", on: { click: _vm.closeCreateViewModal } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("common.cancel")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "primary" },
                      on: { click: _vm.createNewView },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("common.create")) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }